module.exports = __webpack_public_path__ + "img/Party-text.483ef7be.jpg";